import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-background-50">
                Sugargoo<span className="text-primary-400">Sheet</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              The largest English resource hub for Sugargoo Spreadsheet, product research, and China sourcing strategies. Helping dropshippers and sellers find winning products faster.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">Home</Link></li>
              <li><Link to="/shopping-guide" className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">Shopping Guide</Link></li>
              <li><Link to="/blog/sugargoo-spreadsheet-complete-guide" className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">Complete Guide</Link></li>
              <li><a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">Buy Sugargoo Spreadsheet</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Top Guides</h4>
            <ul className="space-y-2.5">
              <li><Link to="/blog/sugargoo-review-2026" className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">Sugargoo Review 2026</Link></li>
              <li><Link to="/blog/sugargoo-shipping-cost-guide" className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">Shipping Cost Guide</Link></li>
              <li><Link to="/blog/sugargoo-coupon-discount-guide" className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">Coupon &amp; Discounts</Link></li>
              <li><Link to="/blog/is-sugargoo-legit" className="text-sm text-background-400 hover:text-primary-300 transition-colors duration-200">Is Sugargoo Legit?</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Disclaimer</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              This is an independent educational resource. We are not affiliated with Sugargoo. All trademarks belong to their respective owners. External links open in new tabs.
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; {new Date().getFullYear()} sugargoosheet.casa. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-sm text-background-500 hover:text-primary-300 transition-colors duration-200">Home</Link>
            <span className="text-background-600">|</span>
            <Link to="/shopping-guide" className="text-sm text-background-500 hover:text-primary-300 transition-colors duration-200">Shopping Guide</Link>
            <span className="text-background-600">|</span>
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-background-500 hover:text-primary-300 transition-colors duration-200">Main Site</a>
          </div>
        </div>
      </div>
    </footer>
  );
}